
<div *ngIf="type=='Off_Represantative very Briefly'">
  <div id="print-section" style="margin-top: 50px; display: flex; justify-content: center;">
    <table class="table table-bordered" style="table-layout: auto; width: auto;">
      <thead>
        <tr>
          <th colspan="9"
            style="border: 1px solid #000; text-align: center; padding: 8px; font-size: 20px; font-weight: bold;">
            Advt Registration Report - Very Briefly Off-Represantative
          </th>
        </tr>
        <tr>
          <th colspan="5"
            style="border: 0px solid #fdfdfd;border-bottom: 1px solid #000;border-top: 1px solid #000;border-left: 1px solid #000;  text-align: center; padding: 5px;font-size: 16px; ">
            <span>हिंदुस्तान प्रकाशन संस्था-विवेक साप्ताहिक</span>
            अंकाची दिनांक: {{ issuedatepp | date: 'dd-MM-yyyy' }}  
          </th>
          <th colspan="4" style="border:1px solid #000;font-size: 14px;font-size: 16px; " class="br-bottom  br-top">
            
            <span style="text-align:end;"><strong>दिनांक :</strong> {{today1}} </span>
          </th>
        </tr>
        <tr>
          <th colspan="5"
            style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-left: 1px solid #000;  text-align: left; padding: 5px;font-size: 16px; ">
            <strong>अंकाचे नाव :</strong> &nbsp; {{newissuedatepp}}
          </th>
          <th colspan="4"
            style="border: 0px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; text-align: center; padding: 5px;font-size: 16px; ">
            <strong>Date : From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy'}}&nbsp;&nbsp;&nbsp;</strong>
          </th>
        </tr>
        <tr>
          <th style="border: 1px solid #000; white-space: nowrap; padding: 4px 8px; font-size: 16px;">Rep Name</th>
          <th
            style="border: 1px solid #000; white-space: nowrap; padding: 4px 8px; font-size: 16px;text-align: center;">
            उद्दिष्ट</th>
          <th style="border: 1px solid #000; text-align: end; white-space: nowrap; padding: 4px 8px; font-size: 16px;">
            Advt<br>Amt</th>
          <th style="border: 1px solid #000; text-align: end; white-space: nowrap; padding: 4px 8px; font-size: 16px;">
            Net<br>Amt</th>
          <th style="border: 1px solid #000; text-align: end; white-space: nowrap; padding: 4px 8px; font-size: 16px;">
            Before<br>GST</th>
          <th style="border: 1px solid #000; text-align: end; white-space: nowrap; padding: 4px 8px; font-size: 16px;">
            GST<br>Amt</th>
          <th
            style="border: 1px solid #000; text-align: end; white-space: nowrap; padding: 4px 8px; font-size: 16px;background-color: yellow;">
            Total<br>Amt</th>
          <th style="border: 1px solid #000; text-align: end; white-space: nowrap; padding: 4px 8px; font-size: 16px;">
            RCV<br>Amt</th>
          <th
            style="border: 1px solid #000; text-align: end; white-space: nowrap; padding: 4px 8px; font-size: 16px;width: 10%;">
            Pending<br>Amt</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item2 of inDetailsRegReportbtoff101">
          <tr>
            <td colspan="4"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;font-size: 15px; padding: 4px 8px;background-color: #8ed9dd;font-weight: bold;"
              class="br-bottom br-right br-top"><span
                style="font-weight:bold">Off-Represantative:</span>&nbsp;&nbsp;{{item2.off_rep_name}}</td>
            <td colspan="5"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;background-color: #8ed9dd;"
              class="br-bottom br-right br-top"></td>

          </tr>
          <ng-container *ngFor="let item1 of item2.rep_data">
            <tr>
              <td style="border:1px solid #000; font-weight:bold; padding: 4px 8px;">{{item1.rep_name}}</td>
              <td style="border:1px solid #000; font-weight:bold; padding: 4px 8px;width: 10%;">
                <input type="number"
       [(ngModel)]="item1.udhistha"
       style="width:100%; border:none; outline:none; font-weight:bold; text-align:end;" />

              </td>
              <td style="border:1px solid #000; text-align:end; padding: 4px 8px;">{{item1.total_advt_amount}}</td>
              <td style=" border:1px solid #000; text-align:end; padding: 4px 8px;">{{item1.total_discounted_amt}}</td>
              <td style="border:1px solid #000; text-align:end; padding: 4px 8px;">{{item1.total_before_gst}}</td>
              <td style="border:1px solid #000; text-align:end; padding: 4px 8px;">{{item1.total_gst}}</td>
              <td style="border:1px solid #000; text-align:end; padding: 4px 8px;background-color: yellow;">
                {{item1.total_amt}}</td>
              <td style="border:1px solid #000; text-align:end; padding: 4px 8px;">{{item1.pymt_rcv_amt}}</td>
              <td style="border:1px solid #000; text-align:end; padding: 4px 8px;">{{item1.total_pending}}</td>
            </tr>
          </ng-container>
          <!-- Off-Rep Total Row -->
          <tr style="background-color: #f8f9fa;">
            <td
              style="border:1px solid #000; text-align:center; font-weight:bold; padding: 4px 8px;background-color: yellow;">
              {{item2.off_rep_name}} Total</td>
            <td
              style="border:1px solid #000; text-align:center; font-weight:bold; padding: 4px 8px;background-color: yellow;">
            </td>
            <td
              style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;background-color: yellow;">
              {{item2.total_advt_amt}}</td>
            <td
              style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;background-color: yellow;">
              {{item2.total_net_amt}}</td>
            <td
              style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;background-color: yellow;">
              {{item2.total_before_gst_amt}}</td>
            <td
              style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;background-color: yellow;">
              {{item2.total_gst_amt}}</td>
            <td
              style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;background-color: yellow;">
              {{item2.total_amount}}</td>
            <td
              style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;background-color: yellow;">
              {{item2.total_receive_amt}}</td>
            <td
              style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;background-color: yellow;">
              {{item2.total_pending_amt}}</td>
          </tr>
        </ng-container>
      </tbody>
      <tfoot>
        
      </tfoot>
      <tr>
          <td style="border:1px solid #000; text-align:center; font-weight:bold; padding: 4px 8px;">एकूण</td>
          <td style="border:1px solid #000; text-align:center; font-weight:bold; padding: 4px 8px;"></td>
          <td style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;">{{advtamtb}}</td>
          <td style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;">{{totaladvtamt}}</td>
          <td style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;">{{totalbeforegst_amt}}
          </td>
          <td style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;">{{totalgst}}</td>
          <td style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;">{{netadvtamt}}</td>
          <td style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;">{{jamatotalb}}</td>
          <td style="border:1px solid #000; text-align:end; font-weight:bold; padding: 4px 8px;">{{netadvtamt -
            jamatotal}}</td>
        </tr>
    </table>
  </div>
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Table</title>
  <style>
    table { border-collapse: collapse; width: 50%; }
    th, td { border: 1px solid black; padding: 8px; text-align: left; }
    .yellow { background-color: #e7e709; }
  </style>
</head>
<body>
  <div class="second-page-table" style="display:flex; justify-content:center;">
    <table>
      <colgroup>
        <col style="width:33%;">
        <col style="width:33%;">
        <col style="width:34%;">
      </colgroup>
      <thead>
        <tr>
          <th colspan="6" class="second-page-header"  style="text-align:center; font-weight:bold; padding:8px; font-size:24px;">
            अंक / ग्रंथ व्यवसाय स्थिती
          </th>
        </tr>
        <tr>
          <th colspan="2" style="text-align:left; font-weight:bold; padding:8px;">
              अंकाची दिनांक: {{ issuedatepp | date: 'dd-MM-yyyy' }}  
          </th>
          <th colspan="4" style="font-weight:bold; padding:8px; text-align:left;">
            दिनांक : <span style="float:right;">{{ today1 }}</span>
          </th>
        </tr>
        <tr>
          <th colspan="4" style="text-align:center; font-weight:bold; padding:8px; text-align:left;">
           अंकाचे नाव : {{ newissuedatepp }}
          </th>
        </tr>
        <tr>
          <th style="text-align:center; font-weight:bold; padding:8px;">Off-Representative</th>
          <th style="text-align:center; font-weight:bold; padding:8px;">उद्दिष्ट</th>
          <th style="text-align:center; font-weight:bold; padding:8px;">TOTAL AMT</th>
          <th style="text-align:center; font-weight:bold; padding:8px;">%</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item2 of inDetailsRegReportbtoff; let i = index">
          <td style="padding:8px; font-weight:bold;">{{ item2.off_rep_name }}</td>

          <!-- udhistha input: two-way bind and notify component on change -->
          <td style="padding:8px;">
            <input type="number"
                   [(ngModel)]="item2.udhistha"
                   (ngModelChange)="onUdhisthaChange(i, $event)"
                   style="width:100%; padding:12px; text-align:right;"
                   placeholder="Enter value">
          </td>

          <td class="yellow" style="text-align:right; padding:8px; font-weight:bold;">
            {{ item2.total_amount  }}
          </td>

         <td style="padding:8px; border-top:2px solid #000; font-weight:bold; text-align:right;font-size: 12px;">
  {{ ((item2.udhistha && item2.udhistha > 0) ? ((item2.total_amount || 0) / item2.udhistha * 100) : 0) | number:'1.2-2' }}%
</td>
        </tr>
      </tbody>

      <tfoot>
  <!-- TOTAL row -->
  <tr>
    <td colspan="1" style="text-align:right; font-weight:bold; padding:8px;">एकूण</td>
    <td style="text-align:right; font-weight:bold; padding:8px;">
      {{ totalUdhistha }}
    </td>
    <td class="yellow" style="text-align:right; font-weight:bold; padding:8px;">
      {{ regularTotalAmt  }}
    </td>
    <td style="text-align:right; font-weight:bold; padding:8px;font-size: 12px;">
      {{ totalUdhisthaPercent | number:'1.2-2' }}%
    </td>
  </tr>

 

  <!-- कार्यालय - जाहिरात विभाग - ONLY IN FOOTER -->
 
<tr>
  <td colspan="1" style="text-align:left; font-weight:bold; padding:8px;">कार्यालय - जाहिरात विभाग</td>
  <td style="padding:8px; border-top:2px solid #000;">
    <input type="number" [(ngModel)]="officeAdvt"
           style="width:100%; padding:12px; text-align:right; border:1px solid #ccc;" placeholder="Enter value">
  </td>
  <td class="yellow" style="padding:8px; border-top:2px solid #000; text-align:right; font-weight:bold;">
    {{ officeTotalAmt }}
  </td>
  <td style="text-align:right; font-weight:bold; padding:8px;font-size: 12px;">
    {{ (officeAdvt && officeAdvt > 0 ? (officeTotalAmt / officeAdvt * 100) : 0) | number:'1.2-2' }}%
  </td>
</tr>


  <!-- एकूण व्यवसाय - Total Business -->
<tr>
  <td colspan="1" style="text-align:right; font-weight:bold; padding:8px;">एकूण व्यवसाय</td>
  <td style="padding:8px; border-top:2px solid #000;text-align: right;font-weight: bold;">
    {{ (totalUdhistha || 0) + (officeAdvt || 0)  }}
  </td>
  <td class="yellow" style="padding:8px; border-top:2px solid #000; font-weight:bold; text-align:right;">
    {{ (regularTotalAmt || 0) + (officeTotalAmt || 0)  }}
  </td>
  <td style="padding:8px; border-top:2px solid #000;font-size: 12px; text-align:right; font-weight:bold;">
    {{
      (
        ((totalUdhistha || 0) + (officeAdvt || 0)) && ((regularTotalAmt || 0) + (officeTotalAmt || 0))
          ? (((regularTotalAmt || 0) + (officeTotalAmt || 0)) /
             ((totalUdhistha || 0) + (officeAdvt || 0)) * 100)
          : 0
      ) | number:'1.2-2'
    }}%
  </td>
</tr>

<!-- मागील वर्षीची आजची स्थिती -->
<tr>
  <td colspan="2" style="text-align:right; font-weight:bold; padding:8px;">
    मागील वर्षीची आजची स्थिती
  </td>
  <td class="yellow" style="padding:8px; border-top:2px solid #000;">
   <input type="number"
       [(ngModel)]="magil_varshachi_aajchi_stithi"
       style="width:100%; padding:12px; text-align:right; border:1px solid #ccc" />
  </td>
  <td style="padding:8px; border-top:2px solid #000;"></td>
</tr>


  <!-- मागील वर्षीच्या तुलनेत -->
<tr>
  <td colspan="2" style="text-align:right; font-weight:bold; padding:8px;">
    मागील वर्षीच्या तुलनेत
  </td>
  <td class="yellow" style="padding:8px; font-weight:bold; text-align:right;">
    {{ ((regularTotalAmt || 0) + (officeTotalAmt || 0)) - (magil_varshachi_aajchi_stithi || 0) }}
  </td>
  <td style="padding:8px;"></td>
</tr>

  <!-- मागील वर्षीच्या एकूण जाहिरात -->
<tr>
  <td colspan="2" style="text-align:right; font-weight:bold; padding:8px;">मागील वर्षीच्या एकूण जाहिरात</td>
  <td class="yellow" style="padding:8px;">
    <input type="number" [(ngModel)]="magil_varshyachya_ekun_jahirata"
           style="width:100%; padding:12px; text-align:right; border:1px solid #ccc;" placeholder="Enter value">
  </td>
  <td style="padding:8px; border-top:2px solid #000;"></td>
</tr>

  <!-- Save Button -->
  <tr class="noPrint">
    <td colspan="4" style="text-align: center; border-top:2px solid #000;">
      <button (click)="saveAll()" 
              style="margin-top:10px; padding:10px 20px; cursor:pointer; background-color:#1fcebf; color:white; border:none; border-radius:4px; font-weight:bold;">
        Save All
      </button>
    </td>
  </tr>
</tfoot>

    </table>
  </div>
</body>
</html>


</div>



<div class="noPrint" style="margin-left: 80%; margin-bottom: 2%">
  <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
    (click)="exportexcel('Registration Report')" style="margin-top: 2%;">
    Export
  </button>

  <button mat-raised-button color="primary" (click)="printPageA4Portrait()" style="margin-top: 2%;">
    Print
  </button>

  <button mat-dialog-close class="btn">Close</button>
</div>